import { authRoleAccess } from 'auth/AuthRoleAccess';
import { lazy } from 'react';

const CallCenterOfficerDashboard = lazy(() => import('./CaseOfficer/OfficerDashboard'));
const CallCenterManagerDashboard = lazy(() => import('./CaseManager/ManagerDashboard'));

const CallCenterPerformanceRoutes = [
  {
    path: '/CallCenterOfficer_performance_dashboard',
    component: CallCenterOfficerDashboard,
    auth: authRoleAccess.call_center_officer_dashboard,
  },
  {
    path: '/CallCenterManager_performance_dashboard',
    component: CallCenterManagerDashboard,
    auth: authRoleAccess.call_center_manager_dashboard,
  },
];

export default CallCenterPerformanceRoutes;
